(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fu-banner-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fu-banner-carousel')) {
  customElements.define('fu-banner-carousel', class extends HTMLElement {
    connectedCallback() {
      this.bootFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.bootFrame);
      clearTimeout(this.timer);
      this.events?.abort();
      this.observer?.disconnect();
      this.widthObserver?.disconnect();
      this.initialized = false;
    }
    init() {
      if (this.initialized) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.slides.length) return;
      this.initialized = true;
      this.events = new AbortController();
      const on = (target, event, handler, options = {}) => target?.addEventListener(event, handler, {...options, signal: this.events.signal});
      const syncWidth = () => {
        if (this.dataset.frame !== 'full') return;
        for (let pass = 0; pass < 2; pass++) {
          const width = document.documentElement.clientWidth;
          if (width !== this.windowWidth) {
            this.windowWidth = width;
            this.style.setProperty('--fu-window-width', `${width}px`);
          }
        }
      };
      syncWidth();
      on(window, 'resize', syncWidth);
      if ('ResizeObserver' in window) {
        this.widthObserver = new ResizeObserver(syncWidth);
        this.widthObserver.observe(document.documentElement);
      }
      this.pickers = [...this.querySelectorAll('[data-picker]')];
      this.rotation = this.querySelector('[data-rotation]');
      this.status = this.querySelector('[data-status]');
      this.controls = this.querySelector('[data-controls]');
      this.index = 0;
      this.hovering = false;
      this.inView = true;
      this.allowFocusedRotation = false;
      this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.enabledAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.userPaused = !this.enabledAutoplay || this.motion.matches || this.dataset.editor === 'true';
      if (this.controls) this.controls.hidden = this.slides.length < 2;
      if (this.rotation) this.rotation.hidden = !this.enabledAutoplay;
      this.select(0, false);
      on(this.querySelector('[data-prev]'), 'click', () => this.select(this.index - 1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.select(this.index + 1, true));
      this.pickers.forEach((button, i) => on(button, 'click', () => this.select(i, true)));
      on(this.rotation, 'pointerdown', () => { this.rotationBeforeFocus = this.userPaused; });
      on(this.rotation, 'click', () => {
        const wasPaused = this.rotationBeforeFocus ?? this.userPaused;
        this.rotationBeforeFocus = undefined;
        this.userPaused = !wasPaused;
        this.allowFocusedRotation = !this.userPaused;
        this.schedule();
      });
      on(this, 'focusin', () => {
        this.userPaused = true;
        this.allowFocusedRotation = false;
        this.schedule();
      });
      on(this, 'mouseenter', () => { this.hovering = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovering = false; this.schedule(); });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => { if (this.motion.matches) this.stop(); });
      on(this.controls, 'keydown', event => {
        const keys = {ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1};
        if (!(event.key in keys)) return;
        event.preventDefault();
        this.select(keys[event.key], true);
      });
      on(this.querySelector('[data-viewport]'), 'pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.pointerStart = {x: event.clientX, y: event.clientY, id: event.pointerId};
      }, {passive: true});
      on(this.querySelector('[data-viewport]'), 'pointerup', event => {
        const start = this.pointerStart;
        this.pointerStart = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        if (Math.abs(dx) < 55 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
        this.suppressClickUntil = Date.now() + 450;
        this.select(this.index + (dx < 0 ? 1 : -1), true);
      }, {passive: true});
      on(this, 'pointercancel', () => { this.pointerStart = null; }, {passive: true});
      on(this, 'click', event => {
        if (Date.now() < (this.suppressClickUntil || 0)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, {capture: true});
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) this.select(index, true);
      });
      on(document, 'shopify:section:unload', event => {
        if (event.target === this || event.target.contains?.(this)) this.disconnectedCallback();
      });
      if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0]?.isIntersecting ?? false;
        this.schedule();
      }, {threshold: 0.15});
      this.observer.observe(this);
      }
      this.schedule();
    }
    stop() {
      this.userPaused = true;
      this.allowFocusedRotation = false;
      this.schedule();
    }
    select(index, manual) {
      if (!this.slides?.length) return;
      if (manual) this.stop();
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        slide.querySelectorAll('a,button').forEach(link => { link.tabIndex = active ? 0 : -1; });
        this.pickers[i]?.setAttribute('aria-current', String(active));
      });
      const count = this.querySelector('[data-count]');
      if (count) count.textContent = String(this.index + 1).padStart(2, '0');
      if (this.status) {
        this.status.setAttribute('aria-live', manual ? 'polite' : 'off');
        this.status.textContent = `Slide ${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].dataset.title || ''}`;
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.initialized) return;
      const focused = this.contains(document.activeElement);
      const rotating = this.enabledAutoplay && !this.userPaused && !document.hidden && this.inView && (!this.hovering || this.allowFocusedRotation) && (!focused || this.allowFocusedRotation);
      if (this.rotation) {
        this.rotation.setAttribute('aria-label', this.userPaused ? 'Start automatic slide rotation' : 'Stop automatic slide rotation');
        this.rotation.querySelector('[data-play]').toggleAttribute('hidden', !this.userPaused);
        this.rotation.querySelector('[data-pause]').toggleAttribute('hidden', this.userPaused);
      }
      this.dataset.rotating = String(Boolean(rotating));
      if (rotating) this.timer = setTimeout(() => this.select(this.index + 1, false), this.interval);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
